import type { ErrorMap } from '@/app/error-registry';

export const TASK_UPDATE_ERROR_MAP: ErrorMap = {
  PATCH: {
    'ProjectTask.NotFound': 'tasks:apiErrors.updateNotFound',
    'ProjectTask.InvalidDateRange': 'tasks:apiErrors.updateInvalidDateRange',
    'ProjectTask.NegativeEstimatedHours': 'tasks:apiErrors.updateNegativeEstimatedHours',
    'ProjectTask.InvalidPriority': 'tasks:apiErrors.updateInvalidPriority',
    'ProjectTask.CannotRescheduleUndatedTask': 'tasks:apiErrors.updateCannotReschedule',
    'ProjectTask.BlockedReasonTooLong': 'tasks:apiErrors.updateBlockedReasonTooLong',
    'ProjectTask.IsArchived': 'tasks:apiErrors.updateIsArchived',
    'TaskTitle.Required': 'tasks:apiErrors.titleRequired',
    'TaskTitle.TooLong': 'tasks:apiErrors.titleTooLong',
    'TaskDescription.TooLong': 'tasks:apiErrors.descriptionTooLong',
    forbidden: 'tasks:apiErrors.updateForbidden',
    validation: 'tasks:apiErrors.updateValidation',
    default: 'tasks:apiErrors.updateDefault',
  },
};

export const TASK_CREATE_ERROR_MAP: ErrorMap = {
  POST: {
    'Project.NotFound': 'tasks:apiErrors.createNotFound',
    'Board.NotFound': 'tasks:apiErrors.createNotFound',
    'CreateTask.InvalidBoardId': 'tasks:apiErrors.createInvalidBoardId',
    'CreateTask.InvalidStatusId': 'tasks:apiErrors.createInvalidStatusId',
    'CreateTask.InvalidGroupId': 'tasks:apiErrors.createInvalidGroupId',
    'CreateTask.InvalidAssigneeId': 'tasks:apiErrors.createInvalidAssigneeId',
    'TaskTitle.Required': 'tasks:apiErrors.titleRequired',
    'TaskTitle.TooLong': 'tasks:apiErrors.titleTooLong',
    'TaskDescription.TooLong': 'tasks:apiErrors.descriptionTooLong',
    forbidden: 'tasks:apiErrors.createForbidden',
    validation: 'tasks:apiErrors.createValidation',
    default: 'tasks:apiErrors.createDefault',
  },
};

export const TASK_DELETE_ERROR_MAP: ErrorMap = {
  DELETE: {
    'ProjectTask.NotFound': 'tasks:apiErrors.deleteNotFound',
    forbidden: 'tasks:apiErrors.deleteForbidden',
    default: 'tasks:apiErrors.deleteDefault',
  },
};

export const TASK_MOVE_ERROR_MAP: ErrorMap = {
  PATCH: {
    'ProjectTask.NotFound': 'tasks:apiErrors.moveNotFound',
    'Status.NotFound': 'tasks:apiErrors.moveNotFound',
    'MoveTask.NoFields': 'tasks:apiErrors.moveNoFields',
    'MoveTask.InvalidStatusId': 'tasks:apiErrors.moveInvalidStatusId',
    'MoveTask.InvalidGroupId': 'tasks:apiErrors.moveInvalidGroupId',
    'MoveTask.InvalidAfterTaskId': 'tasks:apiErrors.moveInvalidAfterTaskId',
    'MoveTask.InvalidAfterTask': 'tasks:apiErrors.moveInvalidAfterTask',
    forbidden: 'tasks:apiErrors.moveForbidden',
    validation: 'tasks:apiErrors.moveValidation',
    default: 'tasks:apiErrors.moveDefault',
  },
};

export const TASK_ASSIGN_ERROR_MAP: ErrorMap = {
  PATCH: {
    'ProjectTask.NotFound': 'tasks:apiErrors.assignNotFound',
    'Member.NotFound': 'tasks:apiErrors.assignNotFound',
    'AssignTask.InvalidAssigneeId': 'tasks:apiErrors.assignInvalidAssigneeId',
    forbidden: 'tasks:apiErrors.assignForbidden',
    validation: 'tasks:apiErrors.assignValidation',
    default: 'tasks:apiErrors.assignDefault',
  },
};

export const TASK_PRIORITY_ERROR_MAP: ErrorMap = {
  PATCH: {
    'ProjectTask.NotFound': 'tasks:apiErrors.priorityNotFound',
    'ChangeTaskPriority.NoPriority': 'tasks:apiErrors.priorityNoPriority',
    forbidden: 'tasks:apiErrors.priorityForbidden',
    validation: 'tasks:apiErrors.priorityValidation',
    default: 'tasks:apiErrors.priorityDefault',
  },
};

export const TASK_TOGGLE_ERROR_MAP: ErrorMap = {
  POST: {
    'ProjectTask.NotFound': 'tasks:apiErrors.toggleNotFound',
    forbidden: 'tasks:apiErrors.toggleForbidden',
    default: 'tasks:apiErrors.toggleDefault',
  },
};

export const TASK_REORDER_ERROR_MAP: ErrorMap = {
  POST: {
    'ReorderTasks.InvalidBoardId': 'tasks:apiErrors.reorderInvalidBoardId',
    'ReorderTasks.InvalidStatusId': 'tasks:apiErrors.reorderInvalidStatusId',
    'ReorderTasks.InvalidTaskId': 'tasks:apiErrors.reorderInvalidTaskId',
    'ProjectTask.ReorderListIncomplete': 'tasks:apiErrors.reorderListIncomplete',
    'ProjectTask.ReorderListContainsForeignTask': 'tasks:apiErrors.reorderForeignTask',
    forbidden: 'tasks:apiErrors.reorderForbidden',
    validation: 'tasks:apiErrors.reorderValidation',
    default: 'tasks:apiErrors.reorderDefault',
  },
};

export const TASK_SUBTASK_CREATE_ERROR_MAP: ErrorMap = {
  POST: {
    'ProjectTask.ParentNotFound': 'tasks:apiErrors.subtaskCreateNotFound',
    'ProjectTask.MaxDepthExceeded': 'tasks:apiErrors.subtaskMaxDepthExceeded',
    'TaskTitle.Required': 'tasks:apiErrors.titleRequired',
    'TaskTitle.TooLong': 'tasks:apiErrors.titleTooLong',
    forbidden: 'tasks:apiErrors.subtaskCreateForbidden',
    validation: 'tasks:apiErrors.subtaskCreateValidation',
    default: 'tasks:apiErrors.subtaskCreateDefault',
  },
};

export const TASK_ATTACHMENTS_ERROR_MAP: ErrorMap = {
  POST: {
    'Attachment.FileTooLarge': 'tasks:apiErrors.attachmentTooLarge',
    'Attachment.MimeTypeNotAllowed': 'tasks:apiErrors.attachmentUnsupportedType',
    default: 'tasks:apiErrors.attachmentDefault',
  },
  DELETE: {
    'Attachment.NotFound': 'tasks:apiErrors.attachmentNotFound',
    default: 'tasks:apiErrors.attachmentDefault',
  },
};

export const TASK_TAGS_ERROR_MAP: ErrorMap = {
  POST: {
    'TaskTag.AlreadyExists': 'tasks:apiErrors.tagAlreadyAttached',
    'TaskTag.TagNotInProject': 'tasks:apiErrors.tagNotInProject',
    'AddTagToTask.InvalidTagId': 'tasks:apiErrors.tagInvalidId',
    notFound: 'tasks:apiErrors.tagNotFound',
    default: 'tasks:apiErrors.tagDefault',
  },
  DELETE: {
    'TaskTag.NotFound': 'tasks:apiErrors.tagNotFound',
    default: 'tasks:apiErrors.tagDefault',
  },
};

export const TASK_COMMENT_ERROR_MAP: ErrorMap = {
  POST: {
    'TaskComment.TaskNotFound': 'tasks:apiErrors.commentTaskNotFound',
    'TaskComment.InvalidParent': 'tasks:apiErrors.commentInvalidParent',
    'CommentContent.Required': 'tasks:apiErrors.commentContentRequired',
    'CommentContent.TooLong': 'tasks:apiErrors.commentContentTooLong',
    default: 'tasks:apiErrors.commentCreateDefault',
  },
  DELETE: {
    'TaskComment.NotFound': 'tasks:apiErrors.commentNotFound',
    'TaskComment.NotAuthor': 'tasks:apiErrors.commentNotAuthor',
    'TaskComment.AlreadyDeleted': 'tasks:apiErrors.commentAlreadyDeleted',
    forbidden: 'tasks:apiErrors.commentDeleteDefault',
    default: 'tasks:apiErrors.commentDeleteDefault',
  },
};

export const TASK_ARCHIVE_ERROR_MAP: ErrorMap = {
  POST: {
    'ProjectTask.NotFound': 'tasks:apiErrors.archiveNotFound',
    'ProjectTask.AlreadyArchived': 'tasks:apiErrors.alreadyArchived',
    'ProjectTask.NotArchived': 'tasks:apiErrors.notArchived',
    forbidden: 'tasks:apiErrors.archiveForbidden',
    default: 'tasks:apiErrors.archiveDefault',
  },
};

export const TASK_COPY_ERROR_MAP: ErrorMap = {
  POST: {
    'ProjectTask.NotFound': 'tasks:apiErrors.copyNotFound',
    default: 'tasks:apiErrors.copyDefault',
  },
};

export const TASK_BULK_EDIT_ERROR_MAP: ErrorMap = {
  PATCH: {
    'ProjectTask.BulkEditTooManyTasks': 'tasks:apiErrors.bulkEditTooManyTasks',
    'Task.CrossProjectBulkEdit': 'tasks:apiErrors.bulkEditCrossProject',
    'Task.EmptyBulkEdit': 'tasks:apiErrors.bulkEditEmpty',
    'BulkEdit.NoFields': 'tasks:apiErrors.bulkEditNoFields',
    'Board.StatusNotFound': 'tasks:apiErrors.bulkEditStatusNotFound',
    'Board.GroupNotFound': 'tasks:apiErrors.bulkEditGroupNotFound',
    'User.NotFound': 'tasks:apiErrors.bulkEditUserNotFound',
    'User.InvalidId': 'tasks:apiErrors.bulkEditInvalidUserId',
    validation: 'tasks:apiErrors.bulkEditValidation',
    default: 'tasks:apiErrors.bulkEditDefault',
  },
};

export const TASK_BULK_DELETE_ERROR_MAP: ErrorMap = {
  DELETE: {
    'ProjectTask.EmptyBulkDelete': 'tasks:apiErrors.bulkDeleteEmpty',
    'ProjectTask.BulkDeleteTooManyTasks': 'tasks:apiErrors.bulkDeleteTooManyTasks',
    validation: 'tasks:apiErrors.bulkDeleteValidation',
    default: 'tasks:apiErrors.bulkDeleteDefault',
  },
};

export const TASK_IMPORT_ERROR_MAP: ErrorMap = {
  POST: {
    'ProjectTask.ImportFileTooLarge': 'tasks:apiErrors.importFileTooLarge',
    'ProjectTask.ImportTooManyRows': 'tasks:apiErrors.importTooManyRows',
    'ProjectTask.ImportEmptyFile': 'tasks:apiErrors.importEmptyFile',
    'ProjectTask.ImportUnsupportedFormat': 'tasks:apiErrors.importUnsupportedFormat',
    'Import.InvalidProjectId': 'tasks:apiErrors.importInvalidProjectId',
    'Import.InvalidBoardId': 'tasks:apiErrors.importInvalidBoardId',
    'Board.NotFound': 'tasks:apiErrors.importBoardNotFound',
    default: 'tasks:apiErrors.importDefault',
  },
};

export const TASK_QUERY_ERROR_MAP: ErrorMap = {
  GET: {
    'GetTasks.InvalidProjectId': 'tasks:apiErrors.invalidProjectId',
    'GetTasks.InvalidBoardId': 'tasks:apiErrors.invalidBoardId',
    'GetTasks.InvalidView': 'tasks:apiErrors.invalidView',
    'GetTasks.InvalidFilters': 'tasks:apiErrors.invalidFilters',
    'GetTasks.InvalidFilterField': 'tasks:apiErrors.invalidFilterField',
    'GetTasks.InvalidSort': 'tasks:apiErrors.invalidSort',
    'GetTasks.InvalidSortField': 'tasks:apiErrors.invalidSortField',
    'GetTasks.InvalidSortDirection': 'tasks:apiErrors.invalidSortDirection',
    'GetTasks.InvalidGroupField': 'tasks:apiErrors.invalidGroupField',
    'GetTasks.InvalidGroupKey': 'tasks:apiErrors.invalidGroupKey',
    'GetTasks.MissingDateRange': 'tasks:apiErrors.missingDateRange',
    default: 'tasks:apiErrors.queryDefault',
  },
};

export const TASK_DEPENDENCY_CREATE_ERROR_MAP: ErrorMap = {
  POST: {
    'ProjectTask.NotFound': 'tasks:apiErrors.dependencyCreateNotFound',
    'TaskDependency.SelfReference': 'tasks:apiErrors.dependencySelfReference',
    'TaskDependency.InvalidLagDays': 'tasks:apiErrors.dependencyInvalidLagDays',
    'TaskDependency.AlreadyExists': 'tasks:apiErrors.dependencyAlreadyExists',
    'TaskDependency.CycleDetected': 'tasks:apiErrors.dependencyCreateCycle',
    'TaskDependency.CrossProjectNotAllowed': 'tasks:apiErrors.dependencyCrossProject',
    'TaskDependency.CascadeDepthExceeded': 'tasks:apiErrors.dependencyCascadeDepthExceeded',
    'TaskDependency.PredecessorNotCompleted': 'tasks:apiErrors.dependencyPredecessorNotCompleted',
    conflict: 'tasks:apiErrors.dependencyCreateCycle',
    validation: 'tasks:apiErrors.dependencyCreateValidation',
    default: 'tasks:apiErrors.dependencyCreateDefault',
  },
};

export const TASK_DEPENDENCY_DELETE_ERROR_MAP: ErrorMap = {
  DELETE: {
    'TaskDependency.NotFound': 'tasks:apiErrors.dependencyDeleteNotFound',
    forbidden: 'tasks:apiErrors.dependencyDeleteForbidden',
    default: 'tasks:apiErrors.dependencyDeleteDefault',
  },
};

/**
 * Setting a custom field's value on a task — PUT /api/tasks/{taskId}/field-values/{fieldId} —
 * and uploading a file for a Files/Signature value — POST .../field-values/{fieldId}/file.
 */
export const TASK_FIELD_VALUE_ERROR_MAP: ErrorMap = {
  PUT: {
    'FieldValue.NotFound': 'tasks:apiErrors.fieldValueNotFound',
    'FieldValue.FieldNotInProject': 'tasks:apiErrors.fieldValueFieldNotInProject',
    'FieldValue.RequiredFieldMissing': 'tasks:apiErrors.fieldValueRequiredMissing',
    'FieldValue.InvalidFormat': 'tasks:apiErrors.fieldValueInvalidFormat',
    'FieldValue.InvalidOption': 'tasks:apiErrors.fieldValueInvalidOption',
    'FieldValue.InvalidUser': 'tasks:apiErrors.fieldValueInvalidUser',
    'FieldValue.RequiresFileUpload': 'tasks:apiErrors.fieldValueRequiresFileUpload',
    default: 'tasks:apiErrors.fieldValueDefault',
  },
  POST: {
    'FieldValue.UnsupportedFieldTypeForFile': 'tasks:apiErrors.fieldValueUnsupportedFieldType',
    'FieldValue.FieldNotInProject': 'tasks:apiErrors.fieldValueFieldNotInProject',
    default: 'tasks:apiErrors.fieldValueFileDefault',
  },
};
